// react
import { useState } from 'react';

// material ui
import { Box } from '@mui/material';

// feature-components
import ImageDisplay from '@/features/devices/components/shared/ImageDisplay';

const UnitImageSection = ({ unit, t }) => {
  const [imageFailed, setImageFailed] = useState(false);

  const [currentUnitId, setCurrentUnitId] = useState(unit?.UnitId);
  const [currentImageHash, setCurrentImageHash] = useState(unit?.ImageHash);

  const imageUrl = (() => {
    if (!unit?.UnitId || !unit?.ImageHash) return null;
    const v = encodeURIComponent(unit.ImageHash);
    return `/api/v1/Units/${encodeURIComponent(unit.UnitId)}/Image?v=${v}`;
  })();

  if (unit?.UnitId !== currentUnitId || unit?.ImageHash !== currentImageHash) {
    setCurrentUnitId(unit?.UnitId);
    setCurrentImageHash(unit?.ImageHash);
    setImageFailed(false);
  }

  const handleImageError = () => setImageFailed(true);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 300,
        bgcolor: (theme) => theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <ImageDisplay
        imageUrl={imageUrl}
        imageFailed={imageFailed}
        onImageError={handleImageError}
        alt="Unit"
        t={t}
      />
    </Box>
  );
};

export default UnitImageSection;
